import React, { CSSProperties, FC } from 'react';

import { Icon } from '@column/column-ui-kit';
import { CountryFlag, countryFlags } from '@column/ui';

import { FlagEdge } from '~/components/FlagEdge';
import { FinancialInstitution } from '~/repositories';
import { titleCase } from '~/util';

import { countryName } from './types';

export const institutionName = (institution: FinancialInstitution) =>
  titleCase(String(institution.fullName ?? institution.shortName ?? ''));

/** The postal address, one line per part, or `undefined` when only the country is known. */
export const institutionAddress = (institution: FinancialInstitution) => {
  if (!institution.streetAddress && !institution.city) {
    return undefined;
  }
  const cityLine = [institution.city && titleCase(institution.city), institution.state].filter(Boolean).join(', ');
  return [
    institution.streetAddress && titleCase(institution.streetAddress),
    [cityLine, institution.zipCode].filter(Boolean).join(' '),
    countryName(institution.countryCode) ?? institution.countryCode,
  ]
    .filter(Boolean)
    .join('\n');
};

/** The institution's round country flag, or a bank icon for countries without one. */
export const InstitutionFlag: FC<{ countryCode?: string; size?: 20 | 32 }> = ({ countryCode, size = 32 }) =>
  countryCode && countryCode.toUpperCase() in countryFlags ? (
    <FlagEdge size={size}>
      <CountryFlag country={countryCode} size={size} />
    </FlagEdge>
  ) : (
    <span
      style={{ width: size, height: size }}
      className="flex shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground"
    >
      <Icon.Bank style={{ '--icon-size': `${size / 2}px` } as CSSProperties} />
    </span>
  );
